'use strict';

var angular:angular.IAngularStatic =  require('angular');
export default angular.module('appConfig', []);

import './appConfig';
import './iconConfig'



// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/appConfig.module.ts